package com.milta.core.localization.translations.de

import com.milta.core.localization.AppStrings

// MIL-53 — German added as a 10th supported language for the Dashboard Web "Paramètres" language
// picker. Every section below is an English-content placeholder (duplicated from translations/en),
// consistent with the project's existing missing-translation fallback convention (see
// milta-localization-check) — only `settings` (added directly in this package, see Settings.kt) is
// genuinely translated into German, since it's the section this ticket actually introduces. A real
// German translation pass for the rest of the app is a separate, follow-up effort.
val DeStrings = AppStrings(
    common = Common,
    auth = Auth,
    errors = Errors,
    home = Home,
    profile = Profile,
    subscription = Subscription,
    route = Route,
    team = Team,
    subscriptionExpired = SubscriptionExpired,
    imports = Imports,
    ocrScan = OcrScan,
    spreadsheetImport = SpreadsheetImport,
    webImportRoute = WebImportRoute,
    loadingAddress = LoadingAddress,
    unlocatedDelivery = UnlocatedDelivery,
    routeCreation = RouteCreation,
    settings = Settings,
    webDashboard = WebDashboard,
    webHistorique = WebHistorique,
    adminUsers = AdminUsers,
    adminPrompts = AdminPrompts,
    adminOcrAnalysis = AdminOcrAnalysis,
    optimizationQuota = OptimizationQuota,
    aiCredit = AiCredit,
    publicPages = PublicPages,
)
